import React from 'react'
import styles from './styles.less'

const Badge = ({ text }) => {
  return <p className={styles.container}>{text}</p>
}

export default Badge
